require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./swisstech-hotel-1-1-17-0.json") })
        }
      }, "path---swisstech-hotel-1-1-17-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---swisstech-hotel-1-1-17-0!./.cache/json/swisstech-hotel-1-1-17-0.json
// module id = 583
// module chunks = 231608221292675